import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "copyBtn", "copyText"]
  static values = {
    msgCopied: { type: String, default: "복사됨!" },
    msgShareText: { type: String, default: "지금 바로 참여하세요" }
  }

  copy() {
    const url = this.urlTarget.value
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => this.showCopied())
    } else {
      // Fallback
      const el = document.createElement("textarea")
      el.value = url
      el.style.position = "fixed"
      el.style.opacity = "0"
      document.body.appendChild(el)
      el.select()
      document.execCommand("copy")
      document.body.removeChild(el)
      this.showCopied()
    }
  }

  showCopied() {
    if (this.hasCopyTextTarget) {
      const original = this.copyTextTarget.textContent
      this.copyTextTarget.textContent = this.msgCopiedValue
      setTimeout(() => {
        this.copyTextTarget.textContent = original
      }, 2000)
    }
  }

  share() {
    const url = this.urlTarget.value
    const title = "Klavy 이벤트"
    const text = this.msgShareTextValue

    if (navigator.share) {
      navigator.share({ title, text, url }).catch(() => {})
    } else {
      this.copy()
    }
  }

  kakao() {
    // Kakao SDK share (optional, falls back to copy)
    this.copy()
  }
}
